import Button from '@rezdy/components/Button';
import { FlexItem } from '@rezdy/components/Flexbox';
import styled from 'styled-components';

export const QRCodeWrapper = styled.div`
    height: 128px;
    width: 128px;
    position: relative;
    margin: 0px auto;
    margin-top: 24px;
    margin-bottom: 24px;
`;

export const QRCodeMask = styled(Button)`
    height: 100%;
    width: 100%;
`;

export const FlexItemWithBox = styled(FlexItem as any)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

// export const
